import { FaCircleXmark } from "react-icons/fa6";
import ClipLoader from "react-spinners/ClipLoader";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const DeleteModal = ({
  handleDeleteModalClose,
  data,
  onDelete,
  isDeleting,
}) => {
  console.log(data);
  return (
    <div>
      <ModalContainer handleClose={handleDeleteModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">Confirm Delete</p>
            <span className="bg-primary-hover d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleDeleteModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div>
            {isDeleting ? (
              <div className="d-flex justify-content-center p-2">
                <ClipLoader color="#01ffff" size="22px" />
              </div>
            ) : (
              <p className="">
                Do you want to delete <b> </b> ?
              </p>
            )}

            <div className="d-flex justify-content-center align-items-center">
              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 second-btn text-white"
                role="button"
                onClick={handleDeleteModalClose}
              >
                <span className={`mx-2 d-flex`}>Cancel</span>
              </div>

              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-danger"
                role="button"
                onClick={() => {
                  onDelete(data.id);
                }}
              >
                <span className={`mx-2 d-flex ${isDeleting ? "p-1" : ""}`}>
                  {isDeleting ? (
                    <ClipLoader color="#01ffff" size="22px" />
                  ) : (
                    "Delete"
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DeleteModal;
